<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('holiday_list') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="/holiday/create" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
            <div class="pull-right">
                <div class="btn-group tool-group" role="group">
                    <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(1)" :class="{active:viewType==1}"><i class="fa fa-th-large" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(0)" :class="{active:viewType==0}"><i class="fa fa-list-ul" aria-hidden="true"></i></button>
                </div>
            </div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="number" class="form-control form-control-sm" value="currentYear" :placeholder="$t('Year')" maxlength="4" v-model="query.Year">
<!--                                <input type="text" class="form-control form-control-sm" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList"/>-->
                            </div>
                        </div>
                        <div class="col-sm-8">
                            <div class="form-group">
                                <button type="button" class="btn btn-default btn-sm" @click="toList"><i class="fa fa-search" aria-hidden="true"></i> {{$t('search')}}</button>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                        <tr>
                            <th style="width: 60px" class="text-center">{{ $t('no') }}</th>
                            <th style="width: 300px">{{ $t('date') }}</th>
                            <th>{{ $t('description') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(ret, index) in records" :key="index">
                            <td class="text-center">{{index+1}}</td>
                            <td><router-link :to="{name: 'holiday_update', params:{id:ret.Id}}">{{$format(ret.OnDate, 'DD/MM/YYYY')}}</router-link></td>
                            <td>{{ret.Description}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function(){
            return {
                query:{
                    Text: '',
                    Page: 1,
                    Total: 0,
                    Limit: 25,
                    Year: new Date().getFullYear()
                },
                records:[],
                viewType: 0,
                currentYear: new Date().getFullYear()
            }
        },
        created: function(){
            this.toList();
        },
        methods: {
            toList(){
                var loading = this.$loading.show();
                this.$api().post('holiday/list', this.query).then(res => {
                    if(this.$isValid(res)){
                        this.records = res.data.Data;
                        this.query.Total = res.Total;
                    }
                }).finally(function() { loading.hide(); });
            },
            paging(e){
                this.query.Page = e;
                this.toList();
            },
            viewTypeChange(n){
                this.viewType = n;
            },
            generateYear() {
                let maxYear = new Date().getFullYear() + 1;
                let minYear = maxYear - 2
                for (let i= maxYear; i >= minYear; i--) {
                    this.years.push(i)
                }
            }
        }
    }
</script>